import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class InvestorProjects extends Component {
     
  state = {
    investor_projects: [],
    formData: {
      id: null,
      investor_project_title: "",
      investor_project_description: "",
      investor_project_img: null,
      investor_project_status: "1",
      investor_project_date: "",
    },
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
    previewImage: null,
  };

  componentDidMount() {
    this.fetchInvestorProjects();

    const modalEl = document.getElementById("investorProjectModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  }

  /** ✅ Fetch all investor projects */
  fetchInvestorProjects = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/projects", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data?.data || [];
      this.setState({ investor_projects: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error:
          err.response?.data?.message ||
          "Failed to load investor projects. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** ✅ Reset form */
  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        investor_project_title: "",
        investor_project_description: "",
        investor_project_img: null,
        investor_project_status: "1",
        investor_project_date: "",
      },
      previewImage: null,
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  /** ✅ Input change */
  handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "investor_project_img") {
      this.setState((prev) => ({
        formData: {
          ...prev.formData,
          investor_project_img: files[0],
        },
        previewImage: files[0] ? URL.createObjectURL(files[0]) : null,
      }));
    } else {
      this.setState((prev) => ({
        formData: {
          ...prev.formData,
          [name]: value,
        },
      }));
    }
  };

  /** ✅ Open modal */
  openModal = (mode = "add", item = null) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("investorProjectModal")
    );

    if (mode === "edit" && item) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: item.id,
          investor_project_title: item.investor_project_title || "",
          investor_project_description: item.investor_project_description || "",
          investor_project_img: null,
          investor_project_status: item.investor_project_status?.toString() ?? "1",
          investor_project_date: item.investor_project_date || "",
        },
        previewImage: item.investor_project_img
          ? `${process.env.REACT_APP_API_BASE_URL}/uploads/investor_projects/${item.investor_project_img}`
          : null,
        error: "",
      });
    } else {
      this.resetForm();
    }

    modal.show();
  };

  /** ✅ Submit add/update */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.investor_project_title) {
      return this.setState({ error: "Investor project title is required." });
    }

    const data = new FormData();
    data.append("investor_project_title", formData.investor_project_title);
    data.append("investor_project_description", formData.investor_project_description);
    data.append("investor_project_status", formData.investor_project_status);
    data.append("investor_project_date", formData.investor_project_date);

    if (formData.investor_project_img) {
      data.append("investor_project_img", formData.investor_project_img);
    }

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");

      if (modalMode === "add") {
        await axios.post("/projects", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/projects/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchInvestorProjects();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("investorProjectModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "Investor project added successfully!"
            : "Investor project updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving investor project.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** ✅ Confirm delete */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(
      document.getElementById("deleteModal")
    );
    modal.show();
  };

  /** ✅ Delete investor project */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/projects/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await this.fetchInvestorProjects();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("deleteModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title: "Investor project deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to delete investor project.",
      });
    }
  };

  render() {
    const {
      investor_projects,
      formData,
      error,
      loading,
      submitting,
      modalMode,
      previewImage,
    } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Investor Projects</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>

                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Investor Project
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}

                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {investor_projects.length > 0 ? (
                            investor_projects.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>
                                  {item.investor_project_img ? (
                                    <img
                                      src={`${baseUrl}/uploads/investor_projects/${item.investor_project_img}`}
                                      alt={item.investor_project_title}
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        objectFit: "cover",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  ) : (
                                    "N/A"
                                  )}
                                </td>
                                <td>{item.investor_project_title}</td>
                                <td>
                                  {item.investor_project_description
                                    ? item.investor_project_description.length > 80
                                      ? item.investor_project_description.substring(0, 80) + "..."
                                      : item.investor_project_description
                                    : "N/A"}
                                </td>
                                <td>
                                  {item.investor_project_status === "1" || item.investor_project_status === 1 ? (
                                    <span className="badge bg-success">Active</span>
                                  ) : (
                                    <span className="badge bg-danger">Inactive</span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", item)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>

                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(item.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No investor projects found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add / Edit Modal */}
        <div className="modal fade" id="investorProjectModal" tabIndex={-1}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add Investor Project" : "Edit Investor Project"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        name="investor_project_status"
                        className="form-select"
                        value={formData.investor_project_status}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Project Title</label>
                      <input
                        type="text"
                        name="investor_project_title"
                        className="form-control"
                        value={formData.investor_project_title}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Project Image</label>
                      <input
                        type="file"
                        name="investor_project_img"
                        className="form-control"
                        accept="image/*"
                        onChange={this.handleChange}
                      />

                      {previewImage && (
                        <div className="mt-3">
                          <img
                            src={previewImage}
                            alt="Preview"
                            style={{
                              width: "120px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Project Description</label>
                      <textarea
                        name="investor_project_description"
                        className="form-control"
                        rows="6"
                        value={formData.investor_project_description}
                        onChange={this.handleChange}
                      ></textarea>
                    </div>

                    {error && (
                      <div className="col-md-12">
                        <div className="alert alert-danger">{error}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>

                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InvestorProjects;
